import { AIProvider } from '../constants/providers';
import { InputType } from '../constants/inputTypes';
import { buildApiUrl } from '../config/env';

// Provider detection functions
export const isAutoSelection = (model) => {
    return model && model.provider === AIProvider.AUTOSELECTION;
};

export const isPerplexity = (model) => {
    return model && model.provider === AIProvider.PERPLEXITY;
};

export const isOpenAI = (model) => {
    return model && model.provider === AIProvider.OPENAI;
};

export const isAnthropic = (model) => {
    return model && model.provider === AIProvider.ANTHROPIC;
};

export const isGoogle = (model) => {
    return model && model.provider === AIProvider.GOOGLE;
};

export const isXAI = (model) => {
    return model && model.provider === AIProvider.xAI;
};

export const isDeepSeek = (model) => {
    return model && model.provider === AIProvider.DEEPSEEK;
};

export const isDeepSeekReasoning = (model) => {
    return model && model.provider === AIProvider.DEEPSEEK_REASONING;
};

export const isLlama = (model) => {
    return model && model.provider === AIProvider.LLAMA;
};

// Model capability functions
export const modelSupportsImages = (model) => {
    return model.supportedInputs && (
        model.supportedInputs.includes(InputType.PNG) || 
        model.supportedInputs.includes(InputType.JPEG)
    );
};

export const modelSupportsFiles = (model) => {
    return model.supportedInputs && model.supportedInputs.includes(InputType.PDF);
};

export const modelSupportsAudio = (model) => {
    return model.supportedInputs && (
        model.supportedInputs.includes(InputType.MP3) || 
        model.supportedInputs.includes(InputType.WAV)
    );
};

export const modelSupportsVideo = (model) => {
    return model.supportedInputs && (
        model.supportedInputs.includes(InputType.MP4) || 
        model.supportedInputs.includes(InputType.MPEG) ||
        model.supportedInputs.includes(InputType.MOV) ||
        model.supportedInputs.includes(InputType.MPG) ||
        model.supportedInputs.includes(InputType.WEBM)
    );
};

export const modelSupportsReasoning = (model) => {
    return model && (model.thinking === true || model.isReasoning === true ||
           model.provider === AIProvider.DEEPSEEK_REASONING);
};

// Utility functions - these need access to the models so they'll be implemented in the index
export const getModelSupportedInputs = (model) => {
    return model?.supportedInputs || [];
};

// Endpoint configuration
export const getEndpoint = (model, hasSubscription) => {
    if (!model) {
        return buildApiUrl('/openai');
    }
    if (isAutoSelection(model)) {
        return hasSubscription
            ? buildApiUrl('/intelligent-model-selection-paid')
            : buildApiUrl('/intelligent-model-selection-free');
    } else if (isPerplexity(model)) {
        return buildApiUrl('/perplexity');
    } else if (isOpenAI(model)) {
        return buildApiUrl('/openai');
    } else if (isAnthropic(model)) {
        return buildApiUrl('/anthropic_web');
    } else if (isGoogle(model)) {
        return buildApiUrl('/gemini');
    } else if (isXAI(model)) {
        return buildApiUrl('/xAI');
    } else if (isDeepSeek(model)) {
        return buildApiUrl('/deepseek');
    } else if (isDeepSeekReasoning(model)) {
        return buildApiUrl('/deepseek_reasoning');
    } else if (isLlama(model)) {
        if ((model.modelString || model.id || '').startsWith('muse-spark-')) {
            return buildApiUrl('/meta');
        }
        return buildApiUrl('/groq');
    }
};
